import { useMutation } from '@tanstack/react-query';
import { API } from 'utils/globalApiServices';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const mutationFn = async ({ file }) => {
  const body = new FormData();
  body.append('file', file);

  const url = `/file/upload/`;
  const { data } = await API.post(url, body);
  return data;
};

const useUploadRecordingMutation = () => {
  const { setTempVideoUrl, setIsLoadingVideoTemp } = RealPlayRecordDataHelper();
  return useMutation({
    mutationFn,
    onMutate: () => {
      setIsLoadingVideoTemp(true);
    },
    onSettled: () => {
      setIsLoadingVideoTemp(false);
    },
    onSuccess: (response) => {
      setTempVideoUrl(response?.url);
    },
    onError: () => {
      setTempVideoUrl('');
      console.log('Unable to upload video, please record again.');
    },
  });
};

export default useUploadRecordingMutation;
